import { render } from "./MaterialRadio.vue?vue&type=template&id=63dd7418&scoped=true"
import script from "./MaterialRadio.vue?vue&type=script&lang=js"
export * from "./MaterialRadio.vue?vue&type=script&lang=js"

import "./MaterialRadio.vue?vue&type=style&index=0&id=63dd7418&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dd7418"]])

export default __exports__